module.exports = __webpack_public_path__ + "static/screen-1@2x-fd1c8c424291e54e1ede3f7e0e30b7b4.png";